var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHaryana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: "1.707in",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 1707 1707",
    width: "1.707in",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m853 1583c-5 0-10-1-14-5-7-5-10-15-7-24 1-5 40-118 165-239 114-110 326-248 685-276 10-1 20 5 23 15s-1 21-10 27l-830 499c-4 2-8 3-12 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m853 1583c-12 0-22-10-22-22v-1212c0-12 10-22 22-22 13 0 23 10 23 22v1212c0 12-10 22-23 22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m848 1041c-43 0-82-16-112-46-32-32-48-75-47-119 1-12 10-21 22-22 45-2 87 15 119 47 31 31 48 74 46 118 0 12-10 21-22 22-2 0-4 0-6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m859 1041c-2 0-4 0-7 0-6 0-11-3-15-7-4-5-7-11-6-17 0-3 0-6 0-9 0-1 0-2 0-2 1-40 18-77 46-105 31-32 74-49 118-47 12 1 22 10 22 22 2 44-15 87-46 119-30 30-70 46-112 46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m848 868c-43 0-82-16-112-46-32-32-48-75-47-119 1-12 10-21 22-22 45-2 87 15 119 47 31 31 48 74 46 118 0 12-10 21-22 22-2 0-4 0-6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m859 868c-2 0-4 0-7 0-12-1-22-11-21-24 0-3 0-6 0-9 0-1 0-2 0-2 1-40 18-77 46-105 31-32 74-49 118-47 12 1 22 10 22 22 2 44-15 87-46 119-30 30-70 46-112 46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m848 695c-43 0-82-16-112-46-32-32-48-75-47-119 1-12 10-21 22-22 45-2 87 15 119 47 31 31 48 74 46 118 0 12-10 21-22 22-2 0-4 0-6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m859 695c-2 0-4 0-7 0-12-1-22-11-21-24 0-3 0-6 0-9 0-1 0-2 0-2 1-40 18-77 46-105 31-32 74-49 118-47 12 1 22 10 22 22 2 44-15 87-46 119-30 30-70 46-112 46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m848 522c-43 0-82-16-112-46-32-32-48-75-47-119 1-12 10-21 22-22 45-2 87 15 119 47 31 31 48 74 46 118 0 12-10 21-22 22-2 0-4 0-6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m859 522c-2 0-4 0-7 0-12-1-22-11-21-24 0-3 0-6 0-9 0-1 0-2 0-2 1-40 18-77 46-105 31-32 74-49 118-47 12 1 22 10 22 22 2 44-15 87-46 119-30 30-70 46-112 46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m853 1583c-1 0-2 0-3 0-12-1-21-13-19-25 81-597 524-939 528-943 10-7 24-5 32 5s6 24-4 31c-5 4-432 335-511 913-2 11-11 19-23 19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1138 904c-5 0-9-1-13-4-34-24-57-61-62-102-6-41 6-83 33-115 7-9 21-11 30-4 34 24 57 61 63 102 5 41-7 83-34 115-4 5-10 8-17 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1218 933c-34 0-68-12-95-34-4-4-7-9-8-16 0-6 2-12 6-16 1-2 3-5 5-7 0-1 1-1 1-2 24-28 57-47 94-52 42-5 84 7 115 33 9 8 11 21 4 31-23 34-61 56-102 62-6 1-13 1-20 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1247 774c-5 0-9-1-13-4-36-25-61-65-67-108-5-44 7-89 36-123 7-9 21-11 30-4 36 26 61 65 66 109 6 44-7 88-35 122-4 6-11 8-17 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1333 806c-36 0-72-13-101-37-4-4-7-9-8-15 0-6 1-12 5-17 2-2 4-5 6-8 1 0 1-1 1-1 26-31 61-50 101-56 44-5 88 7 122 36 9 7 11 20 4 30-25 36-65 61-108 66-7 1-15 2-22 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1420 664c-19 0-37-3-55-9-11-4-17-16-14-27 11-44 41-81 81-102 39-21 87-24 129-9 11 4 17 16 14 27-12 44-41 81-81 102-23 12-49 18-74 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m853 372c-5 0-11-2-15-6-33-30-52-73-52-118s19-88 52-119c9-8 22-8 31 0 33 31 52 74 52 119s-19 88-52 118c-5 4-10 6-16 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m853 1583c-11 0-21-8-22-19-79-578-507-909-511-913-10-7-12-21-4-31 7-10 21-12 31-5 5 4 447 346 529 943 2 12-7 24-20 25-1 0-2 0-3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m569 904c-7 0-13-3-18-8-26-32-38-74-33-115 6-41 28-78 62-102 10-7 23-5 31 4 26 32 38 74 33 115-6 41-28 78-62 102-4 3-9 4-13 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m488 933c-6 0-13 0-20-1-41-5-78-28-102-62-7-10-5-23 4-31 32-26 74-38 115-33 37 5 71 24 95 52 0 1 0 1 1 2 1 2 3 5 5 7 4 5 6 11 5 17 0 6-3 11-8 15-26 22-60 34-95 34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m460 774c-7 0-13-2-18-8-28-34-41-78-35-122s30-84 66-109c10-7 23-5 31 4 28 34 41 79 35 123-6 43-30 83-66 108-4 3-9 4-13 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373 806c-7 0-14-1-21-2-44-5-83-30-109-66-6-10-5-23 4-30 34-28 79-41 123-36 39 6 75 25 100 56 1 0 1 1 1 1 2 3 4 6 6 8 4 5 6 11 6 17-1 6-4 11-9 15-28 24-64 37-101 37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287 664c-26 0-52-6-75-18-39-21-69-58-80-102-3-11 3-23 14-27 42-15 90-12 129 9 40 21 69 58 81 102 3 11-4 23-15 27-17 6-35 9-54 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m853 1583c-4 0-8-1-11-3l-830-499c-9-6-14-17-10-27 3-10 12-16 23-15 359 28 570 166 685 276 125 121 163 234 165 239 3 9 0 19-7 24-5 4-10 5-15 5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaryana);
export default __webpack_public_path__ + "static/media/haryana.acd8063029ae04cd66c7f6bfbe56507e.svg";
export { ForwardRef as ReactComponent };